/* eslint-disable no-dupe-keys */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
} from "../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../layout/head/Head";
import ES4Update from "./ES4Update";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionCDisable from "../../components/DynmicOption/OptionCDisable.";
import * as xlsx from "xlsx";

const ES4DataEdit = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Totall, setTotal] = useState([]);
    const [Change, setchange] = useState(true);
    const [Gloading, setGloading] = useState(false);
    const [GTotal, setGTotal] = useState(0);
    const [userData, setuserData] = useState("");
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [employmentId, setemloymentId] = useState(sessionStorage.getItem("employmentId"));
    const today = new Date();
    const tableRef = useRef(null);
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const [Countdata, setCountdata] = useState(0);
    const [exportloading, setexportloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: sessionStorage.getItem("EmploymentRefId"),
    });
    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const Total = async (empId) => {

        const sendData = {

            EmploymentId: Number(empId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Data/GetES4DetailsTotal1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    //console.log(data[0])
                    setTotal(data[0])
                })


    };

    const getdata2 = async (emp) => {

        const sendData = {

            EmploymentId: (emp),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetEs4param', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    /*console.log(data)*/
                    setdataactive(data)
                    setCountdata(data.length);
                })


    };

    const getdata = async () => {

        const sendData = {
            EmploymentId: Number(employmentId),
            UserId: Number(localStorage.getItem("userId")),
        }


        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Viewalldata', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {

                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        setemloymentId(data.employmentId)
                        getdata2(data.employmentId)
                        setuserData(data)
                        Total(data.employmentId)

                    }

                })


    };

    const generate = async () => {
        if (formData.year > 0 && formData.month > 0) {
        setloading(false)
        setGloading(true)
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            EmploymentRefId: Number(formData.EmploymentRefId),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GenerateEs4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "Error") {
                        Swal.fire({
                            title: ' This Month Report is Already Submitted',
                            icon: 'error',

                        })
                    } else {
                        setloading(false)
                        setGloading(false)
                        getdata()
                    }

                })
    }else {
        Swal.fire({
            icon: "warning",
            title: "Month or Year Not Selected",
            text: "Please Select Month and Year",
            focusConfirm: false,
        }).then(() => {
            props.history.push("/Dashboard")
        })
}


    };


    useEffect(() => {
        if (employmentId > 0) {
            Total(employmentId)
            setchange(!Change)

        }
    }, [GTotal])

    useEffect(() => {

        setloading(true)
        getdata()
    }, [])

    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentId: employmentId,
                }

                //console.log(sendData)
                await fetch(process.env.REACT_APP_API_LINK + 'api/Main/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/Dashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })



    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        getdata()
    };

    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()

    };

    const ADDDynamic = async () => {
        setloading(false)
        const sendData = {
            EmploymentId: employmentId,
            EmploymentRefId: Number(formData.EmploymentRefId),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/DynamicAddEs4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === 'Done') {
                        setloading(true)
                        getdata()
                    } else {
                        window.location.reload()
                    }

                })


    };

    const inputRef = useRef(null);

    const handleClick = () => {
        // 👇️ open file input box on click of another element
        inputRef.current.click();
    };

    const readUploadFile = async (e) => {
        e.preventDefault();
        setexportloading(true);
        if (e.target.files) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const data = e.target.result;
                //console.log(data)
                const workbook = xlsx.read(data, { type: "array" });
                // //console.log(workbook)
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = xlsx.utils.sheet_to_json(worksheet);
                
                // Validate NCO codes before importing
                let hasInvalidNco = false;
                let invalidNcoMessage = '';
                
                for (let item of json) {
                    const ncoValue = String(item.NcoCode20158DigitLevel2).replace(/[^0-9Xx]/g, '');
                    if (ncoValue.length > 0 && ncoValue.length !== 8) {
                        hasInvalidNco = true;
                        if (ncoValue.length > 8) {
                            invalidNcoMessage = `Please verify the 8-character code and try again.`;
                        } else if (ncoValue.length < 8) {
                            invalidNcoMessage = `Please verify the 8-character code and try again.`;
                        }
                        break;
                    }
                }
                
                if (hasInvalidNco) {
                    setexportloading(false);
                    Swal.fire({
                        icon: 'warning',
                        title: 'Invalid NCO Code',
                        text: invalidNcoMessage,
                        confirmButtonText: 'OK'
                    });
                    return;
                }
                
                const senddata = json.map((item, index) => {
                    const { TradeInWhichTrained3, ...rest } = item;
                    return {
                        ...rest,
                        NcoCode20158DigitLevel2: String(item.NcoCode20158DigitLevel2),
                        Apikey1: String(item.TradeInWhichTrained3),
                        Value: index + Countdata + 1,
                        ParametersID: 77,
                        EmploymentId: employmentId,
                    };
                });
                /*console.log("SendData",senddata);*/

                await fetch(
                    process.env.REACT_APP_API_LINK + "api/Main/AdddataexelEs4",
                    {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(senddata),
                    }
                )
                    .then((response) => response.json())
                    .then((data) => {
                        /*console.log("RES_Data",data);*/
                        if (data.length > 0) {
                            setexportloading(false);
                            // ✅ Refresh table data and totals after import
                            getdata2(employmentId);
                            Total(employmentId);

                            // ✅ Show success Swal
                            Swal.fire({
                                icon: 'success',
                                title: 'Upload Successful!',
                                text: 'Your file has been processed and data updated.',
                                showConfirmButton: true,
                                confirmButtonColor: '#3085d6',
                                timer: 4000,
                            });
                        } else {
                            setexportloading(false);
                            Swal.fire({
                                title: "Data Uploaded Failed!!",
                                icon: "error",
                            });
                        }
                    });
            };
            reader.readAsArrayBuffer(e.target.files[0]);
        }
    };

    const handleDownloadXlsx = () => {
        const link = document.createElement('a');

        // Set the download attribute with the file name
        link.download = 'ES4 format.xlsx';

        // Set the href to the path of the file in the public folder
        link.href = '/Excel/ES4.xlsx';

        // Trigger the download by simulating a click
        link.click();
    };

    return (
        <React.Fragment>
            <Head title="ES4-Edit" />
            {exportloading ? (
                <div className="loader-container">
                    <div className="spinner"></div>
                    < div className="message">Please wait while we upload the Excel Data and Do not Refresh the page ⌛ </div>

                </div>
            ) :
                <Content>
                    {loading ? <Spinner color="success" /> :
                        <Block>
                            <Button onClick={() => window.location.href = '/Dashboard'} color="dark"><em className="icon ni ni-back-alt"></em> BACK</Button>
                            <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                                {/* <NavbarDynamic />*/}
                                <div style={{ border: "2px solid black", padding: 10 }}>
                                    <Row className="gy-4" >
                                        <Col md="3">
                                            <h3>
                                                Employment Return (ES4) {" "}
                                            </h3>
                                        </Col>
                                        <Col md="3">
                                            <input
                                                style={{ display: "none" }}
                                                type="file"
                                                name="upload"
                                                id="upload"
                                                onChange={readUploadFile}
                                                ref={inputRef}
                                            />

                                            {Draft ? null : (
                                                <Button style={{ margin: "1.5rem" }} color="success">
                                                    <Icon className="icon ni ni-arrow-up-circle"></Icon>
                                                    <b
                                                        style={{ fontSize: 18 }}
                                                        onClick={() => handleClick()}
                                                    >
                                                        {" "}
                                                        Import Data from Excel{" "}
                                                    </b>
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="3">
                                            {/* Button for custom .xlsx download */}
                                            <Button style={{ margin: '1.5rem' }} color="info" onClick={handleDownloadXlsx}>
                                                <Icon className="icon ni ni-download"></Icon>
                                                <b style={{ fontSize: 18 }}>Download Excel Format</b>
                                            </Button>
                                        </Col>
                                        <Col md="3">
                                            <DownloadTableExcel
                                                filename="ES4 Edit Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                {Draft ? null : <Button style={{ float: "right", margin: '1.5rem' }} color="warning" ><Icon className="icon ni ni-download"></Icon><b style={{ fontSize: 18 }}>Export Excel</b></Button>}
                                            </DownloadTableExcel>{" "}
                                        </Col>
                                    </Row>
                                </div>

                                {Draft ? <Row className="gy-4">

                                    <Col md="6">
                                        <OptionCDisable onInputChange={onInputChange} namemain="year" mainid="year" />
                                    </Col>
                                    {Gloading === false ? <Col md="6">
                                        <Button color="success" onClick={() => generate()} >Generate</Button>
                                    </Col> : <Spinner color="success" />}
                                </Row> :
                                    <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                        <Row className="gy-4">
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Center: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.state : "Not Specified"}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Name of Employment Exchange: <label style={{ fontWeight: "normal" }}>  {userData.user !== undefined ? userData.user.answer1 : "Not Specified"}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        Month: <label style={{ fontWeight: "normal" }}> {month1[userData.monthId]}</label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                            <Col md="6">
                                                <FormGroup>
                                                    <label className="form-label" htmlFor="Month">
                                                        ES 4: Return showing Trade-wise distribution of Craftsmen trained at the ITIs and full term Apprentices trained under the Apprenticeship Act during the month: <label style={{ fontWeight: "normal" }}>  </label>
                                                    </label>

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                            <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                                <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                        <tr >

                                                            <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                S. No.

                                                            </th>
                                                            <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                NCO Code 2015 ( 8 digit level )

                                                            </th>
                                                            <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Trade in which trained

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Ex-ITI Trainees
                                                            </th>

                                                            <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Full term Apprentices

                                                            </th>
                                                        </tr>
                                                        <tr>

                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Registration </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Placement</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 80 }} > Live Register</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Registration </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Placement</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 80 }} > Live Register</td>
                                                        </tr>










                                                    </thead>

                                                    <tbody>

                                                        {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                            details.parentId === 0 ?(
                                                                <tr key={index} scope="row" >
                                                                    <td >
                                                                        <b>  {details.value}</b>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                <ES4Update
                                                                    key={index}
                                                                    Change={Change}
                                                                    value={details.value}
                                                                    setGTotal={setGTotal}
                                                                    GTotal={GTotal}
                                                                    edit={true}
                                                                    es4detailsId={details.es4detailsId}
                                                                    employmentId={employmentId}
                                                                    ES4Update={ES4Update}
                                                                    />
                                                                )
                                                        ) : null}
                                                        <tr>
                                                            <td>
                                                                <Button color="success" onClick={() => ADDDynamic()}>ADD</Button>
                                                            </td>
                                                        </tr>
                                                        <tr scope="row" >
                                                            <td>
                                                                <b>  Total</b>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            {/*<td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.ncoCode20158DigitLevel2}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.tradeInWhichTrained3}
                                                        </td>*/}
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.registration4}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.placement5}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.liveRegister6}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.registration7}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.placement8}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.liveRegister9}
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </div>

                                            <div style={{ visibility: 'hidden', height: 0, width: 0 }} className="table-responsive">
                                                <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                        <tr >

                                                            <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                S. No.

                                                            </th>
                                                            <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit', minWidth: 150 }} >
                                                                NCO Code 2015 ( 8 digit level )

                                                            </th>
                                                            <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Trade in which trained

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Ex-ITI Trainees
                                                            </th>

                                                            <th colSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                                Full term Apprentices

                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Registration </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Placement</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 80 }} > Live Register</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Registration </td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }} >Placement</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold", minWidth: 80 }} > Live Register</td>
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {dataactive.length > 0 ? dataactive.map((details, index) =>
                                                            details.parentId === 0 ?(
                                                                <tr key={index} scope="row" >
                                                                    <td >
                                                                        <b>  {details.value}</b>
                                                                    </td>
                                                                </tr>
                                                            ) :(
                                                                <ES4Update
                                                                    key={index}
                                                                    Change={Change}
                                                                    value={details.value}
                                                                    setGTotal={setGTotal}
                                                                    GTotal={GTotal}
                                                                    edit={false}
                                                                    es4detailsId={details.es4detailsId}
                                                                    employmentId={employmentId}
                                                                    ES4Update={ES4Update}
                                                                />
                                                                )
                                                        ) : null}

                                                        <tr scope="row" >
                                                            <td>
                                                                <b>  Total</b>
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                            {/*<td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.ncoCode20158DigitLevel2}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: 10 }}>
                                                            {Totall.tradeInWhichTrained3}
                                                        </td>*/}
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.registration4}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.placement5}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.liveRegister6}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.registration7}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.placement8}
                                                            </td>
                                                            <td style={{ textAlign: 'center', padding: 10 }}>
                                                                {Totall.liveRegister9}
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </div>

                                        </div>
                                        <div style={{ marginTop: 30, marginRight: -10 }}>
                                            <Button color='info' onClick={() => onSaveDraft()}>Save As Draft<em className="icon ni ni-unarchive"></em></Button>  <Button onClick={onFormSubmit} color='success'>Submit <em className="icon ni ni-file-check"></em></Button> <Button color='warning' onClick={() => onSaveDraftGoBack()}>Save As Draft And Back To Dashboard<em className="icon ni ni-signout"></em></Button>
                                        </div>
                                    </Card>}



                            </Card>

                        </Block>}

                </Content>
            }
        </React.Fragment>
    );
};

export default ES4DataEdit;
